import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { WorkspaceProvider } from "@/context/WorkspaceContext";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import PaintBoard from "@/pages/PaintBoard";
import Deliveries from "@/pages/Deliveries";
import { Manifests, ManifestDetail } from "@/pages/Manifests";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import CostCatalog from "@/pages/CostCatalog";
import Stripe from "@/pages/Stripe";
import Team from "@/pages/Team";
import ApplianceDashboard from "@/pages/appliance/ApplianceDashboard";
import ApplianceDocuments from "@/pages/appliance/ApplianceDocuments";
import ApplianceDocumentDetail from "@/pages/appliance/ApplianceDocumentDetail";
import ApplianceReport from "@/pages/appliance/ApplianceReport";
import PwaInstallPrompt from "@/components/PwaInstallPrompt";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <Protected>
            <AppShell />
          </Protected>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="orders" element={<Orders />} />
        <Route path="orders/:id" element={<OrderDetail />} />
        <Route path="paint" element={<PaintBoard />} />
        <Route path="deliveries" element={<Deliveries />} />
        <Route path="manifests" element={<Manifests />} />
        <Route path="manifests/:id" element={<ManifestDetail />} />
        <Route path="catalog" element={<CostCatalog />} />
        <Route path="reports" element={<Reports />} />
        <Route path="stripe" element={<Stripe />} />
        <Route path="team" element={<Team />} />
        <Route path="settings" element={<Settings />} />
        {/* Appliance Depot workspace */}
        <Route path="appliance" element={<ApplianceDashboard />} />
        <Route path="appliance/documents" element={<ApplianceDocuments />} />
        <Route path="appliance/documents/:id" element={<ApplianceDocumentDetail />} />
        <Route path="appliance/report" element={<ApplianceReport />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <WorkspaceProvider>
          <AppRoutes />
          <PwaInstallPrompt />
          <Toaster
            position="top-right"
            toastOptions={{
              style: { background: "#fff", border: "1px solid #E2E1DD", color: "#1A1A18" },
            }}
          />
        </WorkspaceProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
